import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import ModalComponent from '../../common/ModalComponent/ModalComponent';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ErrorBoundary from '../ErrorBoundary';

const CancelRapidManual = forwardRef((props, ref) => {
	const [open, setOpen] = useState(false);
	const [className, setClassName] = useState('testClass');
	const [params, setParams] = useState('');

	useEffect(() => {
		props.open({
			handleClick: (parms) => handleClick(parms),
		});
		return () => {
			if(props.open){
				props.open(null);
			}
		};
	}, []);

	useImperativeHandle(ref, () => {
		handleClick: handleClick;
	});

	const closeModal = (event) => {
		setClassName('testClass');
		setOpen(false);
		if (props.rootClosexit) {
			props.rootClosexit(event);
		} else {
			event.stopPropagation();
			event.nativeEvent.stopImmediatePropagation();
			return false;
		}
	};

	const handleClick = (params) => {
		setOpen(true);
		if (params) {
			setParams(params);
		}
	};

	const handleClose = () => {
		setOpen(true);
		setClassName('animated shake Data-Management');
		setTimeout(() => setClassName('Data-Management'), 1000);
	};

	const handleRevert = () => {
		setClassName('Data-Management');
		setOpen(false);
		props.cancelRapidUpdate(params);
		props.revertRapidChanges();
	};

	return (
		<div>
			<ErrorBoundary>
				<ModalComponent
					open={open}
					backdrop={true}
					content={
						<div className="jconfirm-box-container">
							<div className="jconfirm-content-pane">
								<div style={{ fontSize: 18 }}>
									Are you sure you want to cancel or move away from this page and
									lose any unsaved annotations?
								</div>
							</div>
							<div className="jconfirm-content-pane">
								<div className="jconfirm-buttons">
									<button
										type="button"
										className="btn btn-default"
										onClick={(event) => closeModal(event)}
									>
										Cancel
									</button>
									<button
										type="button"
										className="btn btn-default"
										onClick={() => handleRevert()}
									>
										Ok
									</button>
								</div>
							</div>
						</div>
					}
					className={'testClass'}
					handleClose={handleClose}
				/>
			</ErrorBoundary>
		</div>
	);
});

CancelRapidManual.propTypes = {
	cancelRapidUpdate: PropTypes.func,
	open: PropTypes.func,
	revertRapidChanges: PropTypes.func,
	rootClosexit: PropTypes.func,
};

const mapStateToProps = (state) => state;
export default withRouter(connect(mapStateToProps)(CancelRapidManual));
